import React, { Component } from 'react'

import { connect } from 'react-redux'

import styled from 'styled-components'

import Sidebar from '../Sidebar'
import Bottombar from '../Bottombar/Bottombar'

const MainVisual = styled.main`
  position: relative;
  left: 250px;
  top: 0;

  width: calc(100vw - 250px);
  height: calc(100vh - 100px);

  transition: transform 500ms ease-out, width 500ms ease-out;
  ${props => !props.sidebarIsOpen && `
    transform: translate(-250px, 0px);
    width: 100%;
  `}

  /* Tinted background */
  background: linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/img/main-bg.jpg');
  background-size: cover;
  overflow-y: scroll;
`

const mapStateToProps = (state) => ({
  sidebarIsOpen: state.sidebar.isOpen
})

let Layout = (props) => (
  <div>
    <Sidebar />
    <MainVisual {...props}>
      {props.children}
    </MainVisual>
    <Bottombar track={{name: 'Chapter 6', duration: 10.4}}/>
  </div>
)

Layout = connect(mapStateToProps, {})(Layout)

export default Layout



// WEBPACK FOOTER //
// ./src/components/Main/Layout.js